import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { app } from "../../Frame/App";
import { MsoTable } from "./MsoTable";
import { ListItem } from "../../Model/ListItem";

export class ColumnAmpel extends ColumnBase {

    public getContent(row: any): HTMLElement {
        let icon = this.def.dataField == "SubAmpel" ? "fas fa-tasks-alt ampel-icon" : "ampel"

        if (app.isPagStrategy2030) {
            if (app.isNullOrUndefined(row[this.def.dataField])) {
                row[this.def.dataField] = 0;
            }
            switch (row[this.def.dataField]) {
                case 0:
                    return <div className={`${icon} ampel-green`}></div>;
                case 1:
                    return <div className={`${icon} ampel-yellow`}></div>;
                case 2:
                    return <div className={`${icon} ampel-red`}></div>;
                case 3:
                    return <div className={`${icon} ampel-green`}></div>;
                case 4:
                    return <div className={`${icon} ampel-onhold`}></div>;
                //return <div className="ampel ampel-blue"></div>;
            }
        }
        else {
            switch (row[this.def.dataField]) {
                case 0:
                    return <div className={`${icon} ampel-red`}></div>;
                case 1:
                    return <div className={`${icon} ampel-yellow`}></div>;
                case 2:
                    return <div className={`${icon} ampel-blue`}></div>;
                case 3:
                    return <div className={`${icon} ampel-green`}></div>;
                case 4:
                    return <div className={`${icon} ampel-onhold`}></div>;
            }
        }
        return null;
    }

    public getCellClass(): string {
        let className = super.getCellClass() + " mt-ampel";
        return className;
    }

    public compare(modelA: any, modelB: any, asc: boolean): number {
        let aValue = app.anyToInt(modelA[this.field], 0);
        let bValue = app.anyToInt(modelB[this.field], 0);

        if (asc) {
            return aValue - bValue;
        }
        else {
            return bValue - aValue;
        }
    }

    public getUniqueVisibleItems(table: MsoTable): Array<ListItem> {
        let result = new Array<ListItem>();
        let dict: { [id: number]: number } = {};
        for (let model of this.getRowModelsForFilter(table)) {
            const ampel = app.anyToInt(model[this.field]);
            if (!(ampel in dict)) {
                dict[ampel] = 1;
            }
        }

        for (let ampel in dict) {
            switch (ampel) {
                case "0":
                    result.push({ id: ampel, name: Resources.Common.ampelRed  });
                    break;
                case "1":
                    result.push({ id: ampel, name: Resources.Common.ampelYellow });
                    break;
                case "2":
                    result.push({ id: ampel, name: Resources.Common.ampelBlue });
                    break;
                case "3":
                    result.push({ id: ampel, name: Resources.Common.ampelGreen });
                    break;
                case "4":
                    result.push({ id: ampel, name: Resources.Common.ampelOnHold });
                    break;
            }
        }

        result.sort((a: ListItem, b: ListItem): number => {
            return a.name.localeCompare(b.name);
        });

        return result;
    }
}